import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { Tables } from "@/integrations/supabase/types";

export type LandingSettings = Tables<"cms_landing_page">;
export type LandingItem = Tables<"cms_landing_items">;

export const LANDING_SECTIONS = ["feature", "gallery", "testimonial"] as const;
export type LandingSection = (typeof LANDING_SECTIONS)[number];

export function useLandingSettings() {
  return useQuery({
    queryKey: ["cms-landing-page"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("cms_landing_page")
        .select("*")
        .order("created_at", { ascending: true })
        .limit(1)
        .maybeSingle();
      if (error) throw error;
      return data as LandingSettings | null;
    },
  });
}

export function useLandingItems(activeOnly = false) {
  return useQuery({
    queryKey: ["cms-landing-items", activeOnly],
    queryFn: async () => {
      let query = supabase
        .from("cms_landing_items")
        .select("*")
        .order("display_order", { ascending: true });
      if (activeOnly) query = query.eq("is_active", true);
      const { data, error } = await query;
      if (error) throw error;
      return (data ?? []) as LandingItem[];
    },
  });
}
